import React from 'react';
import { Row, Col, Avatar, Typography, Space, Button } from 'antd';
import { ProjectOutlined, CalendarOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const WelcomeSection = ({ user }) => {
  return (
    <div className="mb-6">
      <Row gutter={[16, 16]} align="middle">
        <Col>
          <Avatar size={64} src={user.avatar} />
        </Col>
        <Col flex={1}>
          <Title level={3} className="mb-1">欢迎回来，{user.name}！</Title>
          <Text type="secondary">{user.department} · {user.position}</Text>
        </Col>
        <Col>
          <Space>
            <Button type="primary" icon={<ProjectOutlined />}>新建项目</Button>
            <Button icon={<CalendarOutlined />}>查看日程</Button>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default WelcomeSection;